/**
 * @fileoverview POST handler for the "/oauth/authorize" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { oauthAuthorizeCacheKeys } from "./constants";
import type { PostOAuthAuthorizeProps, OAuthAuthorizedResult, OAuthAuthorizedResultErrors } from "./types";

export const postOAuthAuthorize = reactQueryMutationAdapter(
  oauthAuthorizeCacheKeys,
  createMutationFetcherFunctionWithShadowError<OAuthAuthorizedResultErrors>()(
    (props: PostOAuthAuthorizeProps): Promise<OAuthAuthorizedResult> => {
      const params = new URLSearchParams();
      params.append("client_id", props.client_id);
      params.append("redirect_uri", props.redirect_uri);
      params.append("response_type", props.response_type);
      params.append("scope", props.scope);
      params.append("c_id", props.c_id);
      if (props.state) {
        params.append("state", props.state);
      }
      if (props.code_challenge) {
        params.append("code_challenge", props.code_challenge);
      }
      if (props.code_challenge_method) {
        params.append("code_challenge_method", props.code_challenge_method);
      }

      return fetch(
        "/oauth/authorize",
        "POST",
        undefined,
        {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: params.toString(),
        },
        {
          // don't display a modal on fetch errors
          propagateFetchRequestError: false,
          setContentType: true,
        }
      );
    }
  )
);
